import { Grid } from "@material-ui/core";
import { DeepPartial } from "redux";
import { VerificationDTO } from "../../../store/verification/models/dto/due-diligence";
import { HeaderContainer, LaunchLogo } from "./header";

export function PreviewHeader({
  imageData,
  cssValue,
  text,
}: {
  imageData?: string;
  text?: string;
  cssValue: DeepPartial<
    VerificationDTO.Requests.DueDiligence.Config.Post.T["header"]["css"]
  >;
}) {
  return (
    <Grid item xs={12}>
      <HeaderContainer colour="#000000" {...cssValue.backgroundColor}>
        {imageData ? <LaunchLogo src={imageData} /> : null}
        <p>{text}</p>
      </HeaderContainer>
    </Grid>
  );
}
